import React from 'react'
import styles from './TileRow.module.css'

type TileRowProps = {
    children: React.ReactNode;
    compact?: boolean;
}

const TileRow = ({ children, compact }: TileRowProps) => {
  return (
    <div className={styles.container} style={compact ? { gap: '0.5rem', flex: 1, display: 'flex' } : {}}>
        {children}
    </div>
  )
}

export default TileRow